import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row mb-2" }
const _hoisted_3 = { class: "col-sm-12" }
const _hoisted_4 = { class: "row mt-2" }
const _hoisted_5 = { class: "col-sm-12 d-flex align-items-center p-2 mt-3 justify-content-center" }
const _hoisted_6 = { class: "row mt-2" }
const _hoisted_7 = {
  for: "amount",
  class: "col-sm-12 col-form-label text-capitalize-first"
}
const _hoisted_8 = { class: "col-sm-12" }
const _hoisted_9 = { class: "row mt-2" }
const _hoisted_10 = {
  for: "traders",
  class: "col-sm-12 col-form-label text-capitalize-first"
}
const _hoisted_11 = { class: "col-sm-12" }
const _hoisted_12 = { class: "d-flex justify-content-between w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccountWidget = _resolveComponent("AccountWidget")!
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _ctx.helper.trans('labels.transfer'),
    modelValue: _ctx.modal !== null,
    "footer-class": "",
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ($event === false && (_ctx.modal = null)))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modal = null)),
          class: "btn btn-outline-secondary btn-sm text-capitalize-first"
        }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
        _createVNode(_component_LoaderWrapper, {
          ref: "saveLoader",
          zoom: 0.5
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.save())),
              class: "btn btn-outline-primary btn-sm text-capitalize-first"
            }, _toDisplayString(_ctx.helper.trans('button.ok')), 1)
          ]),
          _: 1
        }, 512)
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.account)
        ? (_openBlock(), _createElementBlock("form", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_AccountWidget, {
                      "show-icon": "",
                      account: _ctx.account
                    }, null, 8, ["account"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("label", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_ctx.helper.trans("labels.amount")) + " ", 1),
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.form.amount = _ctx.numberFormatter.formatNumber(_ctx.account.sum.amount, _ctx.account.sum.subunit)), ["prevent"]))
                    }, [
                      _createElementVNode("small", null, _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.account.sum.amount, _ctx.account.sum.subunit)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_FormInputWrapper, {
                      errors: _ctx.getErrors(`amount`)
                    }, {
                      default: _withCtx((parentProps) => [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.amount) = $event)),
                          class: _normalizeClass([parentProps.class, "form-control"]),
                          type: "text",
                          id: "amount"
                        }, null, 2), [
                          [_vModelText, _ctx.form.amount]
                        ])
                      ]),
                      _: 1
                    }, 8, ["errors"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.helper.trans("labels.store")), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_FormInputWrapper, {
                      errors: _ctx.getErrors(`targetAccountId`)
                    }, {
                      default: _withCtx((parentProps) => [
                        _createVNode(_component_Multiselect, {
                          id: "traders",
                          modelValue: _ctx.form.store,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.store) = $event)),
                          options: _ctx.options,
                          "custom-label": (opt) => `${opt.merchantName} - ${opt.name} (${opt.currency})`,
                          "track-by": "id",
                          "select-label": "Select",
                          placeholder: _ctx.helper.trans('labels.stores'),
                          "open-direction": "bottom",
                          multiple: _ctx.multiple,
                          searchable: true,
                          loading: _ctx.isLoading,
                          "internal-search": false,
                          "clear-on-select": !_ctx.multiple,
                          "close-on-select": !_ctx.multiple,
                          "options-limit": 100,
                          limit: 1000,
                          "show-no-results": false,
                          "hide-selected": _ctx.multiple,
                          onSearchChange: _ctx.asyncFindStores
                        }, null, 8, ["modelValue", "options", "custom-label", "placeholder", "multiple", "loading", "clear-on-select", "close-on-select", "hide-selected", "onSearchChange"])
                      ]),
                      _: 1
                    }, 8, ["errors"])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}